<p-toast></p-toast>

<div class="tmpl-page">

  <!-- Page Header -->
  <div class="tmpl-header">
    <h2 class="tmpl-title">Templates</h2>
    <div class="tmpl-controls">
      <div class="switch-tabs">
        <button [class.active]="activeTab === '0'" (click)="activeTab = '0'">Templates</button>
        <button [class.active]="activeTab === '1'" (click)="activeTab = '1'">Forms</button>
        <button [class.active]="activeTab === '2'" (click)="activeTab = '2'">Template List</button>
      </div>
      @if (canCreate) {
        <button class="tmpl-btn-new" (click)="openAddTemplate(activeTabType)" [disabled]="isProjectInactive">
          <i class="ri-add-line"></i>
          New Template
        </button>
      }
    </div>
  </div>

  <!-- Templates Tab -->
  @if (activeTab === '0') {
    <div class="tmpl-table">
      <div class="tmpl-row tmpl-row--header">
        <div class="tmpl-cell tmpl-cell--name">Name</div>
        <div class="tmpl-cell tmpl-cell--shortcode">Short Code</div>
        <div class="tmpl-cell tmpl-cell--desc">Description</div>
        <div class="tmpl-cell tmpl-cell--active">Active</div>
        <div class="tmpl-cell tmpl-cell--skids">Equipment</div>
        <div class="tmpl-cell tmpl-cell--date">Updated</div>
        <div class="tmpl-cell tmpl-cell--action tmpl-cell--action-header">Action</div>
      </div>
      @for (group of getGroupedData(filteredTemplates); track group.businessUnitId) {
        <div class="tmpl-group" (click)="toggleGroup('templates', group.businessUnitId)">
          <i [class]="isGroupExpanded('templates', group.businessUnitId) ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"></i>
          <span class="tmpl-group-name">{{ group.name }}</span>
          <span class="tmpl-group-count">{{ group.items.length }}</span>
        </div>
        @if (isGroupExpanded('templates', group.businessUnitId)) {
          @for (tmpl of group.items; track tmpl.templateId; let odd = $odd) {
            <div class="tmpl-row" [class.tmpl-row--alt]="odd">
              <div class="tmpl-cell tmpl-cell--name">
                <a class="tmpl-link" [routerLink]="['/projectchecksheet', projectId, tmpl.templateId]">
                  {{ tmpl.templateName }}
                </a>
              </div>
              <div class="tmpl-cell tmpl-cell--shortcode tmpl-text">{{ tmpl.shortCode || '-' }}</div>
              <div class="tmpl-cell tmpl-cell--desc tmpl-text">{{ tmpl.description || '-' }}</div>
              <div class="tmpl-cell tmpl-cell--active">
                <p-toggleswitch [(ngModel)]="tmpl.isActive"
                  (onChange)="toggleProjectTemplateActive(tmpl)"
                  [pTooltip]="tmpl.isActive ? 'Click to deactivate' : 'Click to activate'"
                  tooltipPosition="top"
                  [disabled]="!canUpdate || isProjectInactive">
                </p-toggleswitch>
              </div>
              <div class="tmpl-cell tmpl-cell--skids">
                <p-multiSelect
                  [options]="getTemplateSkidOptions(tmpl.templateId)"
                  [ngModel]="getTemplateSkids(tmpl.templateId)"
                  (ngModelChange)="onTemplateSkidsChange(tmpl, $event)"
                  optionLabel="label"
                  optionValue="value"
                  optionDisabled="disabled"
                  [showToggleAll]="true"
                  [filter]="true"
                  filterBy="label"
                  placeholder="Select Equipments"
                  appendTo="body"
                  styleClass="w-full"
                  [disabled]="!canEquipmentAssign || isProjectInactive || isTemplateSkidSaving(tmpl.templateId)">
                </p-multiSelect>
              </div>
              <div class="tmpl-cell tmpl-cell--date tmpl-text">{{ tmpl.updatedAt | date:'MMM dd, yyyy' }}</div>
              <div class="tmpl-cell tmpl-cell--action">
                <button class="tmpl-icon-btn" pTooltip="View" tooltipPosition="top"
                  (click)="navigateToChecksheet(tmpl.templateId)">
                  <i class="ri-eye-line"></i>
                </button>
                @if (canUpdate) {
                  <button class="tmpl-icon-btn" pTooltip="Edit" tooltipPosition="top"
                    (click)="openEditTemplate(tmpl, TEMPLATE_TYPE.TEMPLATE)" [disabled]="isProjectInactive">
                    <i class="ri-pencil-line"></i>
                  </button>
                }
                @if (canCreate) {
                  <button class="tmpl-icon-btn" pTooltip="Clone" tooltipPosition="top"
                    (click)="openCloneDialog(tmpl, TEMPLATE_TYPE.TEMPLATE)" [disabled]="isProjectInactive">
                    <i class="ri-file-copy-line"></i>
                  </button>
                }
                @if (canDelete) {
                  <button class="tmpl-icon-btn tmpl-icon-btn--danger" pTooltip="Delete" tooltipPosition="top"
                    (click)="deleteTemplate(tmpl, TEMPLATE_TYPE.TEMPLATE)" [disabled]="isProjectInactive">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                }
              </div>
            </div>
          }
        }
      }
      @if (filteredTemplates.length === 0) {
        <div class="tmpl-empty">No templates found.</div>
      }
    </div>
  }

  <!-- Forms Tab -->
  @if (activeTab === '1') {
    <div class="tmpl-table">
      <div class="tmpl-row tmpl-row--header">
        <div class="tmpl-cell tmpl-cell--name">Name</div>
        <div class="tmpl-cell tmpl-cell--shortcode">Short Code</div>
        <div class="tmpl-cell tmpl-cell--desc">Description</div>
        <div class="tmpl-cell tmpl-cell--active">Active</div>
        <div class="tmpl-cell tmpl-cell--date">Updated</div>
        <div class="tmpl-cell tmpl-cell--action tmpl-cell--action-header">Action</div>
      </div>
      @for (group of getGroupedData(filteredForms); track group.businessUnitId) {
        <div class="tmpl-group" (click)="toggleGroup('forms', group.businessUnitId)">
          <i [class]="isGroupExpanded('forms', group.businessUnitId) ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"></i>
          <span class="tmpl-group-name">{{ group.name }}</span>
          <span class="tmpl-group-count">{{ group.items.length }}</span>
        </div>
        @if (isGroupExpanded('forms', group.businessUnitId)) {
          @for (tmpl of group.items; track tmpl.templateId; let odd = $odd) {
            <div class="tmpl-row" [class.tmpl-row--alt]="odd">
              <div class="tmpl-cell tmpl-cell--name">
                <a class="tmpl-link" [routerLink]="['/projectchecksheet', projectId, tmpl.templateId]">
                  {{ tmpl.templateName }}
                </a>
              </div>
              <div class="tmpl-cell tmpl-cell--shortcode tmpl-text">{{ tmpl.shortCode || '-' }}</div>
              <div class="tmpl-cell tmpl-cell--desc tmpl-text">{{ tmpl.description || '-' }}</div>
              <div class="tmpl-cell tmpl-cell--active">
                <p-toggleswitch [(ngModel)]="tmpl.isActive"
                  (onChange)="toggleProjectTemplateActive(tmpl)"
                  [pTooltip]="tmpl.isActive ? 'Click to deactivate' : 'Click to activate'"
                  tooltipPosition="top"
                  [disabled]="!canUpdate || isProjectInactive">
                </p-toggleswitch>
              </div>
              <div class="tmpl-cell tmpl-cell--date tmpl-text">{{ tmpl.updatedAt | date:'MMM dd, yyyy' }}</div>
              <div class="tmpl-cell tmpl-cell--action">
                <button class="tmpl-icon-btn" pTooltip="View" tooltipPosition="top"
                  (click)="navigateToChecksheet(tmpl.templateId)">
                  <i class="ri-eye-line"></i>
                </button>
                @if (canUpdate) {
                  <button class="tmpl-icon-btn" pTooltip="Edit" tooltipPosition="top"
                    (click)="openEditTemplate(tmpl, TEMPLATE_TYPE.FORMS)" [disabled]="isProjectInactive">
                    <i class="ri-pencil-line"></i>
                  </button>
                }
                @if (canCreate) {
                  <button class="tmpl-icon-btn" pTooltip="Clone" tooltipPosition="top"
                    (click)="openCloneDialog(tmpl, TEMPLATE_TYPE.FORMS)" [disabled]="isProjectInactive">
                    <i class="ri-file-copy-line"></i>
                  </button>
                }
                @if (canDelete) {
                  <button class="tmpl-icon-btn tmpl-icon-btn--danger" pTooltip="Delete" tooltipPosition="top"
                    (click)="deleteTemplate(tmpl, TEMPLATE_TYPE.FORMS)" [disabled]="isProjectInactive">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                }
              </div>
            </div>
          }
        }
      }
      @if (filteredForms.length === 0) {
        <div class="tmpl-empty">No forms found.</div>
      }
    </div>
  }

  <!-- Template List Tab -->
  @if (activeTab === '2') {
    <div class="tmpl-table">
      <div class="tmpl-row tmpl-row--header">
        <div class="tmpl-cell tmpl-cell--name">Name</div>
        <div class="tmpl-cell tmpl-cell--shortcode">Short Code</div>
        <div class="tmpl-cell tmpl-cell--desc">Description</div>
        <div class="tmpl-cell tmpl-cell--active">Active</div>
        <div class="tmpl-cell tmpl-cell--date">Updated</div>
        <div class="tmpl-cell tmpl-cell--action tmpl-cell--action-header">Action</div>
      </div>
      @for (group of getGroupedData(filteredGenericTemplates); track group.businessUnitId) {
        <div class="tmpl-group" (click)="toggleGroup('generic', group.businessUnitId)">
          <i [class]="isGroupExpanded('generic', group.businessUnitId) ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"></i>
          <span class="tmpl-group-name">{{ group.name }}</span>
          <span class="tmpl-group-count">{{ group.items.length }}</span>
        </div>
        @if (isGroupExpanded('generic', group.businessUnitId)) {
          @for (tmpl of group.items; track tmpl.templateId; let odd = $odd) {
            <div class="tmpl-row" [class.tmpl-row--alt]="odd">
              <div class="tmpl-cell tmpl-cell--name">
                <a class="tmpl-link" [routerLink]="['/projectchecksheet', projectId, tmpl.templateId]">
                  {{ tmpl.templateName }}
                </a>
              </div>
              <div class="tmpl-cell tmpl-cell--shortcode tmpl-text">{{ tmpl.shortCode || '-' }}</div>
              <div class="tmpl-cell tmpl-cell--desc tmpl-text">{{ tmpl.description || '-' }}</div>
              <div class="tmpl-cell tmpl-cell--active">
                <p-toggleswitch [(ngModel)]="tmpl.isActive"
                  (onChange)="toggleProjectTemplateActive(tmpl)"
                  [pTooltip]="tmpl.isActive ? 'Click to deactivate' : 'Click to activate'"
                  tooltipPosition="top"
                  [disabled]="!canUpdate || isProjectInactive">
                </p-toggleswitch>
              </div>
              <div class="tmpl-cell tmpl-cell--date tmpl-text">{{ tmpl.updatedAt | date:'MMM dd, yyyy' }}</div>
              <div class="tmpl-cell tmpl-cell--action">
                <button class="tmpl-icon-btn" pTooltip="View" tooltipPosition="top"
                  (click)="navigateToChecksheet(tmpl.templateId)">
                  <i class="ri-eye-line"></i>
                </button>
                @if (canUpdate) {
                  <button class="tmpl-icon-btn" pTooltip="Edit" tooltipPosition="top"
                    (click)="openEditTemplate(tmpl, TEMPLATE_TYPE.GENERIC)" [disabled]="isProjectInactive">
                    <i class="ri-pencil-line"></i>
                  </button>
                }
                @if (canCreate) {
                  <button class="tmpl-icon-btn" pTooltip="Clone" tooltipPosition="top"
                    (click)="openCloneDialog(tmpl, TEMPLATE_TYPE.GENERIC)" [disabled]="isProjectInactive">
                    <i class="ri-file-copy-line"></i>
                  </button>
                }
                @if (canDelete) {
                  <button class="tmpl-icon-btn tmpl-icon-btn--danger" pTooltip="Delete" tooltipPosition="top"
                    (click)="deleteTemplate(tmpl, TEMPLATE_TYPE.GENERIC)" [disabled]="isProjectInactive">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                }
              </div>
            </div>
          }
        }
      }
      @if (filteredGenericTemplates.length === 0) {
        <div class="tmpl-empty">No template list items found.</div>
      }
    </div>
  }

</div>

<!-- Add / Edit Dialog -->
<p-dialog #addEditDialog [(visible)]="showDialog" [modal]="true" [style]="{width: '32rem'}"
  [styleClass]="dialogOpening ? 'kansei-dialog tmpl-add-dialog tmpl-add-dialog--opening' : 'kansei-dialog tmpl-add-dialog'" [closable]="true" [maximizable]="true"
  (onShow)="onTemplateDialogShow(addEditDialog)"
  (onMaximize)="onTemplateDialogMaximize($event)"
  [contentStyle]="{'overflow-y': 'auto'}">

  <ng-template pTemplate="header">
    <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:var(--space-3);width:100%">
      <div>
        <div class="tmpl-dlg-title">{{ isEdit ? 'Edit Template' : 'Add Template' }}</div>
        <div class="tmpl-dlg-subtitle">Fill in the details below to {{ isEdit ? 'update' : 'create' }} the template.</div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <form [formGroup]="form">
      <div class="tmpl-dlg-fields">
        <div class="tmpl-field">
          <label class="modal-label">Name <span class="tmpl-req">*</span></label>
          <input pInputText formControlName="templateName" placeholder="Enter" class="w-full" />
          @if (form.get('templateName')?.invalid && form.get('templateName')?.touched) {
            <small class="tmpl-field-error">Name is required.</small>
          }
        </div>

        <div class="tmpl-field">
          <label class="modal-label">Description</label>
          <input pInputText formControlName="description" placeholder="Enter" class="w-full" />
        </div>

        <div class="tmpl-field">
          <label class="modal-label">Type <span class="tmpl-req">*</span></label>
          <p-select [options]="templateTypeList" formControlName="typeId" placeholder="Select"
            appendTo="body" optionValue="templateTypeId" optionLabel="typeName" class="w-full" [disabled]="true" />
          @if (form.get('typeId')?.invalid && form.get('typeId')?.touched) {
            <small class="tmpl-field-error">Type is required.</small>
          }
        </div>

        <div class="tmpl-field">
          <label class="modal-label">Short Code <span class="tmpl-req">*</span></label>
          <input pInputText formControlName="shortCode" placeholder="Max 16" [maxlength]="16" class="w-full" />
          @if (form.get('shortCode')?.invalid && form.get('shortCode')?.touched) {
            @if (form.get('shortCode')?.errors?.['required']) {
              <small class="tmpl-field-error">Short Code is required.</small>
            } @else if (form.get('shortCode')?.errors?.['maxlength']) {
              <small class="tmpl-field-error">Max 16 characters.</small>
            }
          }
        </div>

        @if (currentTemplateType !== TEMPLATE_TYPE.GENERIC) {
          <div class="tmpl-field">
            <label class="modal-label">Project Roles</label>
            <p-multiSelect [options]="projectRoles" formControlName="selectedRoleIds" placeholder="Select Roles"
              appendTo="body" optionValue="roleId" optionLabel="roleName" class="w-full"
              [showToggleAll]="true" [filter]="true" [disabled]="isReadOnly" />
          </div>
        }

        <div class="tmpl-field">
          <label class="modal-label">Business Unit</label>
          <p-select [options]="businessUnits" formControlName="businessUnitId" placeholder="Select"
            appendTo="body" optionValue="id" optionLabel="displayName" class="w-full" />
        </div>

        <div class="tmpl-field-check">
          <p-checkbox formControlName="isActive" [binary]="true" inputId="ptIsActive" />
          <label for="ptIsActive" class="tmpl-check-label">Active</label>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showDialog = false">Cancel</button>
      <button type="button" class="modal-btn-primary" [disabled]="form.invalid || !canSaveTemplate" (click)="saveTemplate()">Save</button>
    </div>
  </ng-template>

</p-dialog>

<!-- Clone Dialog -->
<p-dialog header="Clone Template" [(visible)]="showCloneDialog" [modal]="true" [style]="{width: '28rem'}"
  [contentStyle]="{ overflow: 'hidden', padding: '0' }"
  styleClass="kansei-dialog">
  <div class="tmpl-dlg-fields" style="padding-top: 4px;">
    <div class="tmpl-field">
      <label class="modal-label">Template Name</label>
      <input pInputText [(ngModel)]="cloneTemplateName" placeholder="Enter" class="w-full" />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="modal-btn-cancel" (click)="showCloneDialog = false">Cancel</button>
    <button type="button" class="modal-btn-primary" (click)="saveClone()"
      [disabled]="!cloneTemplateName.trim()">Clone</button>
  </div>
</p-dialog>
